import { Editor } from '@tinymce/tinymce-react'
import { useEffect, useRef } from 'react'

/**
 * Builder'ın zengin metin alanı.
 *
 * Araç çubuğu bilinçli olarak dar tutulmuştur: v2 motoru HTML'i OOXML'e çevirirken yalnız bu alt kümeyi
 * güvenle destekliyor (punto ve renk span[style] üzerinden taşınır ve motorda karşılığı vardır).
 * Toolbar'a yeni bir buton eklemeden önce motorun (BlockWriter → HtmlToOpenXml) o etiketi
 * çevirebildiğinden emin ol.
 *
 * `registerInsert` ile dışarıya bir "imlece metin ekle" fonksiyonu verir; placeholder paleti bunu kullanır.
 */
export default function RichText({ value, onChange, height = 340, apiKey = '', registerInsert, disabled }) {
    const editorRef = useRef(null)

    useEffect(() => () => { if (registerInsert) registerInsert(null) }, [registerInsert])

    return (
        <Editor
            apiKey={apiKey || undefined}
            value={value || ''}
            disabled={disabled}
            onEditorChange={(html) => onChange(html)}
            onInit={(_, editor) => {
                editorRef.current = editor
                if (registerInsert) registerInsert((text) => editor.insertContent(text))
            }}
            init={{
                height,
                min_height: 220,
                menubar: false,
                // Boyutlandırma tutamacı durum çubuğunda yaşıyor; uzun metinlerde alan büyütülebilsin
                // diye çubuk açık, içindeki gereksiz öğeler (eleman yolu, marka) kapalı.
                statusbar: true,
                elementpath: false,
                resize: true,
                branding: false,
                language: 'tr',
                plugins: 'lists table link',
                toolbar:
                    'undo redo | fontsizeselect | forecolor backcolor | bold italic underline | ' +
                    'alignleft aligncenter alignright alignjustify | ' +
                    'bullist numlist | outdent indent | removeformat',
                toolbar_mode: 'wrap',
                fontsize_formats: '8pt 9pt 10pt 11pt 12pt 14pt 16pt 18pt 20pt 24pt 28pt 36pt',
                // Girinti padding yerine margin ile verilir; ikisini de motor w:ind'e çeviriyor,
                // margin Word'de daha öngörülebilir davranıyor.
                indent_use_margin: true,
                // Motor tarafında desteklenmeyen etiketler baştan engellenir.
                // [style] eklenen etiketlerde girinti/hizalama ve renk-punto bilgisi korunur.
                valid_elements:
                    'p[style],br,strong/b,em/i,u,span[style],div[style],' +
                    'ul[style],ol[style],li[style],' +
                    'h1[style],h2[style],h3[style],h4[style],h5[style],h6[style],' +
                    'table[border|style],thead,tbody,tr,td[colspan|rowspan|style],th[colspan|rowspan|style],a[href]',
                content_style: 'body { font-family: "Times New Roman", serif; font-size: 12pt; }',
            }}
        />
    )
}
